import { useEffect } from 'react';

export function useJSCCollector({
    onInitialized,
    onValidated,
    isRidpRbaEnabled
}: {
    onInitialized: (payload: string) => void;
    onValidated: (payload: string) => void;
        isRidpRbaEnabled: boolean;
}) {

    useEffect(() => {

        if (isRidpRbaEnabled) {
            if ((window as any).xp) {
                (window as any).xp({
                    onInitialize: onInitialized,
                    onValidate: onValidated,
                });
                return;
            }

            // Initialize once script is available 
            const interval = setInterval(() => {
                if ((window as any).xp) {
                    (window as any).xp({
                        onInitialize: onInitialized,
                        onValidate: onValidated,
                    });
                    clearInterval(interval);
                }
            }, 1000);

            return () => {
                clearInterval(interval);
            };
        }
    }, []);
}
